import { render, staticRenderFns } from "./MiniApp.vue?vue&type=template&id=13b11794&scoped=true&"
import script from "./MiniApp.vue?vue&type=script&lang=js&"
export * from "./MiniApp.vue?vue&type=script&lang=js&"
import style0 from "./MiniApp.vue?vue&type=style&index=0&id=13b11794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b11794",
  null
  
)

export default component.exports